<template>
  <div>
    <el-row>
      <el-col :span="1" style="margin-left: 20px;margin-right: 30px;margin-top: 20px">
        <img src="@/assets/patient/patient_cal.png"/>
      </el-col>
      <el-col :span="20" style="margin-top: 20px; color: white;font-weight: 300;line-height: 44px;font-size: 28px; ">
        <el-row style="font-size: 20px;font-weight: bold;">
        </el-row>
      </el-col>
    </el-row>
    <el-tabs v-model="activeName" style="margin-top: 10px;margin-left: 10px" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first" :lazy=true>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">
                <div slot="header" class="clearfix" style="border: none">
                  <i class="el-icon-card-header"></i>
                  <span>基本信息</span>
                </div>
                <el-row :gutter="20">
                  <div v-for="(item,key) in data" :key="key" class="text item">
                    <el-col :span="3" class="el-col-tbl-key">{{ key }}</el-col>
                    <el-col :span="9" class="el-col-tbl-val">
                      {{ ((key == '电话号码' || key == '出生日期' || key == '年龄') && isDemo) ? "******" : item }}
                    </el-col>
                  </div>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-tabs v-model="activeName1" style="margin-top: 10px;margin-left: 10px" @tab-click="handleClick1">
      <el-tab-pane label="内科" name="sec1" :lazy=true>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">
                <el-row :gutter="20">
                  <div v-for="(item,key) in data_sub[0]" :key="key" class="text item">
                    <el-col :span="3" class="el-col-tbl-key">{{ key }}</el-col>
                    <el-col :span="9" class="el-col-tbl-val">
                      {{
                        ((key == '电话号码' || key == '出生日期' || key == '年龄') && isDemo) ? "******" : item
                      }}
                    </el-col>
                  </div>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="五官科" name="sec2" :lazy=true>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">

                <el-row :gutter="20">
                  <div v-for="(item,key) in data_sub[1]" :key="key" class="text item">
                    <el-col :span="3" class="el-col-tbl-key">{{ key }}</el-col>
                    <el-col :span="9" class="el-col-tbl-val">
                      {{
                        ((key == '电话号码' || key == '出生日期' || key == '年龄') && isDemo) ? "******" : item
                      }}
                    </el-col>
                  </div>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="外科" name="sec3" :lazy=true>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">

                <el-row :gutter="20">
                  <div v-for="(item,key) in data_sub[2]" :key="key" class="text item">
                    <el-col :span="3" class="el-col-tbl-key">{{ key }}</el-col>
                    <el-col :span="9" class="el-col-tbl-val">
                      {{
                        ((key == '电话号码' || key == '出生日期' || key == '年龄') && isDemo) ? "******" : item
                      }}
                    </el-col>
                  </div>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="口腔科" name="sec4" :lazy=true>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">

                <el-row :gutter="20">
                  <div v-for="(item,key) in data_sub[3]" :key="key" class="text item">
                    <el-col :span="3" class="el-col-tbl-key">{{ key }}</el-col>
                    <el-col :span="9" class="el-col-tbl-val">
                      {{
                        ((key == '电话号码' || key == '出生日期' || key == '年龄') && isDemo) ? "******" : item
                      }}
                    </el-col>
                  </div>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="妇科" name="sec5" :lazy=true>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">

                <el-row :gutter="20">
                  <div v-for="(item,key) in data_sub[4]" :key="key" class="text item">
                    <el-col :span="3" class="el-col-tbl-key">{{ key }}</el-col>
                    <el-col :span="9" class="el-col-tbl-val">
                      {{
                        ((key == '电话号码' || key == '出生日期' || key == '年龄') && isDemo) ? "******" : item
                      }}
                    </el-col>
                  </div>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
// import PieChart from "@/views/charts/pie";
// import LineChart from "@/views/charts/line";
import '@/assets/css/main.css';
import {Role} from "@/role";

export default {
  name: "TijianInfo",
  components: {
    // PieChart,
    // LineChart,
  },
  computed: {
    isDemo: function () {
      return this.$store.getters.user_role === Role.Demo
    },
  },
  data() {
    return {
      data: null,
      data_sub: new Array(),
      activeName: "first",
      activeName1: "sec1",
      user_profile_data: null,
      user_treat_hist: null,
      patient_mr_brief_data: null,
      avg_temp: null,
      yinqing_dict: null,
      title_today: '2021-01-01',
      brid: this.$route.query.brid,
      load: {
        first: true,
        second: false,
      },
      load1: {
        sec1: true,
        sec2: false,
        sec3: false,
        sec4: false,
        sec5: false,
        sec6: false,
      },
    }
  },
  mounted() {
    this.get_br_tijian_info();
    this.get_br_tijian_info_sub('五官科', 1);
    this.get_br_tijian_info_sub('外科', 2);
    this.get_br_tijian_info_sub('口腔科', 3);
    this.get_br_tijian_info_sub('妇科', 4);
    this.get_br_tijian_info_sub('内科', 0);
  },

  methods: {
    handleClick(tab, event) {
      console.log(event)
      if (this.load[tab.name] === false) {
        this.load[tab.name] = true
      }
    },
    handleClick1(tab, event) {
      console.log(event)
      if (this.load1[tab.name] === false) {
        this.load1[tab.name] = true
      }
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
    get_br_tijian_info() {
      // console.log('bump')
      this.$http.get(process.env.VUE_APP_API_HOST + "/third_party/tijian_info?brid=" + this.brid).then((res) => {
        // console.log(res);
        this.data = res.data.data[0]
      })
    },
    get_br_tijian_info_sub(sub, id) {
      // console.log('bump')
      this.$http.get(process.env.VUE_APP_API_HOST + "/third_party/tijian_info_sub?brid=" + this.brid + "&sub=" + sub).then((res) => {
        // console.log(res);
        this.data_sub[id] = res.data.data[0]
      })
    },
  }
}
</script>

<style scoped>
.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}


/deep/ .el-tabs__item {
  color: white !important;
  font-size: 20px;
}

/deep/ .el-tabs__item.is-active {
  color: white !important;
  font-size: 20px;
}

/deep/ .el-tabs__active-bar {
  background-color: #68F5B9 !important;
}

.swiper {
  height: 75px;
  width: 100%;
}

.swiper .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-weight: bold;
  font-size: 18px;
  background-color: #42444F;
  cursor: pointer;
  flex-direction: column;
}


/*.swiper-slide-active {*/
/*  background-color: #575350 !important;*/
/*}*/

.swiper-button-prev {
  color: #33CD80 !important;
}

.swiper-button-next {
  color: #33CD80 !important;
}

</style>
